angular.module('ApptBookApp').filter('item', function () {
    return function (item) {
        if (!isObject(item)) {
            return '';
        };

        var shortcut = item.shortcut == undefined ? '' : item.shortcut;
        var displayName = item.displayName == undefined ? '' : item.displayName;
        var display = shortcut;
        if (display != '' && displayName != '') {
            display += ": ";
        }
        display += displayName;
        return display;
    };
});